import { Action } from "../../../libs/redux/action";
import {
    QUOTATION_PAYMENT_CLOSE_POPUP,
    QUOTATION_PAYMENT_OPEN_POPUP,
    QUOTATION_PAYMENT_SUBMIT,
    QUOTATION_PAYMENT_SET_CARD_PAYFORM_CONFIGURATION,
    QUOTATION_PAYMENT_LOAD_NIUBIZ_SESSION,
} from "../constants";
import { QuotationPaymentState } from "../state";

export class QuotationPaymentSubmit extends Action<
    SummaryFormModel,
    QuotationPaymentState
> {
    readonly type = QUOTATION_PAYMENT_SUBMIT;
    reducer(state: QuotationPaymentState): QuotationPaymentState {
        return {
            ...state,
        };
    }
}

export class QuotationPaymentOpenPopup extends Action<
    string,
    QuotationPaymentState
> {
    readonly type = QUOTATION_PAYMENT_OPEN_POPUP;
    reducer(state: QuotationPaymentState): QuotationPaymentState {
        return {
            ...state,
            paymentMethod: this.payload,
            popup: {
                opened: true,
            },
        };
    }
}

export class QuotationPaymentClosePopup extends Action<
    void,
    QuotationPaymentState
> {
    readonly type = QUOTATION_PAYMENT_CLOSE_POPUP;
    reducer(state: QuotationPaymentState): QuotationPaymentState {
        return {
            ...state,
            paymentMethod: null,
            popup: {
                opened: false,
            },
        };
    }
}

export class QuotationPaymentSetCardPayformConfiguration extends Action<
    Partial<QuotationPaymentState["card"]["payformConfiguration"]>,
    QuotationPaymentState
> {
    readonly type = QUOTATION_PAYMENT_SET_CARD_PAYFORM_CONFIGURATION;
    reducer(state: QuotationPaymentState): QuotationPaymentState {
        return {
            ...state,
            card: {
                ...state.card,
                payformConfiguration: {
                    ...state.card?.payformConfiguration,
                    ...this.payload,
                },
            },
        };
    }
}

export class QuotationPaymentLoadNiubizSessionAction extends Action<
    void,
    QuotationPaymentState
> {
    readonly type = QUOTATION_PAYMENT_LOAD_NIUBIZ_SESSION;
    reducer(state: QuotationPaymentState): QuotationPaymentState {
        return state;
    }
}
